module.exports = __webpack_public_path__ + "static/media/ic-crm-secured.a21b1828.svg";